export const SAVE_DATA_USER_LOGIN = 'SAVE_DATA_USER_LOGIN'
export const ERROR_USER_LOGIN = 'ERROR_USER_LOGIN'
export const LOADING_USER_LOGIN = 'LOADING_USER_LOGIN'
export const DATA_PERMISSIONS_USER = 'DATA_PERMISSIONS_USER'
export const STATUS_MENU_OPEN = 'STATUS_MENU_OPEN'
export const EMAIL_AZURE = 'EMAIL_AZURE'
export const GET_DATA_COUNTRIES_LOGIN = 'GET_DATA_COUNTRIES_LOGIN'
export const TIME_SCROLL = 'TIME_SCROLL'
export const OPEN_CHROME_MODAL_STATE = 'OPEN_CHROME_MODAL_STATE'